import { render, staticRenderFns } from "./ReviewsCategoriesTableContainer.vue?vue&type=template&id=2dcb1d8a&scoped=true&"
import script from "./ReviewsCategoriesTableContainer.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTableContainer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTableContainer.vue?vue&type=style&index=0&id=2dcb1d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb1d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
